import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'ba-business-data',
  templateUrl: './business-data.component.html',
  styleUrls: ['./business-data.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class BusinessDataComponent implements OnInit {
  options: any[] = [
    {
      value: 'true',
      label: 'Sí',
    },
    {
      value: 'false',
      label: 'No',
    },
  ];

  constructor() {}

  ngOnInit(): void {}
}
